import React, { useEffect, useRef, useState } from "react";
import Layout from "../Layout";
import BetSlip from "./BetSlip";
import { useNavigate, useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import Selection from "./Selection";
import Fancy from "./Fancy";
import LiveMatchTrackerCricket from "../Score/Cricket/ScoerBoardDetail";
import SportsBook from "./SportsBook";
import { motion } from "framer-motion";
import Bookmaker from "./Bookmaker";
import { formatNumber } from "../../Utils/Toast";
import BeforeLoaderDetail from "./BeforeLoaderDetail";
import BetSlipIcon from "../../component/BetSlipIcon";
import MyBets from "../../component/MyBets";
import CustomToast from "../../Utils/CustomToast";
import ParlaySportbook from "./ParlaySportbook";
import BetSlipParly from "../../component/BetSlipParly";
import BookPosition from "./BookPosition";
import LoadingImage from "../../assets/images/cover-live.webp";
import ReactPlayer from "react-player";
import { useMatchDetailLogic } from "../useLogic/useMatchDetailLogic";
import { isMobile } from "react-device-detect";
import { IoVolumeMuteSharp } from "react-icons/io5";
const MatchDetail = () => {
  const parmas = useParams();
  const navigate = useNavigate();
  const ref = useRef(null);
  const {
    // context
    user,
    profileData,
    showBetDialog,
    toastObject,
    setToastObject,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setFancyModal,
    loading,
    setLoading,
    mute,
    setMute,
    tvClass,
    setTvClass,
    fancyTab,
    setFancyTab,
    marketNew,
    marketName,
    setMarketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,
    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,
    runner,
    setRunner,
    runnerOdds,
    fancyHeader,
    favouriteList,
    loader,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,
    showFancy,
    showSportbook,
  } = useMatchDetailLogic();

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      // Check if scroll is past 200px and page height > 1200
      if (showBetDialog) {
        setTvClass(false);
        setActiveTab("scoreboard");
      } else {
        if (scrollY >= 130 && pageHeight > 1000) {
          setTvClass(true);
        } else {
          setTvClass(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check in case user is already scrolled
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showBetDialog]);
  const displayScore = () => {
    return (
      <div className="s-bg-secondary">
        {" "}
        {detail?.eventId && detail?.eventId.toString().startsWith("-1") ? (
          <LiveMatchTrackerCricket type="inner" scoreId={detail?.scoreId} />
        ) : (
          <iframe
            style={{ width: "100%", height: "270px" }}
            src={detail?.scoreURL}
          />
        )}
      </div>
    );
  };
  const [activeTab, setActiveTab] = useState("scoreboard"); // Default selected ta
  const tabs =
    !isEmpty(user) && detail?.status == "in_play"
      ? [
          {
            key: "tv",
            label: "TV",
            icon: "s-icon-live-tv",
          },
          { key: "scoreboard", label: "Scoreboard" },
        ]
      : [{ key: "scoreboard", label: "Scoreboard" }];

  const ScoreboardTabs = () => {
    return (
      <div className="s-w-full s-h-full s-flex s-justify-center s-items-end">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;

          return (
            <div
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`s-mode-tab s-relative s-w-90px s-h-27px s-flex s-justify-center s-items-center s-text-center s-rounded-tl-md s-rounded-tr-md first:s--mr-2.5px last:s--ml-2.5px s-z-30 cursor-pointer ${
                isActive
                  ? "is-active s-bg-scoreboard-tab-bg-active s-text-scoreboard-tab-text-active s-z-40"
                  : "s-bg-scoreboard-tab-bg s-text-scoreboard-tab-text"
              }`}
            >
              {/* Show icon only if tab has one */}
              {tab.icon && (
                <span
                  className={`${tab.icon} s-block s-mr-4px s-text-17px ${
                    isActive
                      ? "s-text-scoreboard-tab-text-active"
                      : "s-text-scoreboard-tab-text"
                  }`}
                />
              )}

              {/* Tab Label */}
              <span className="s-leading-27px s-text-14px">{tab.label}</span>

              {/* Left SVG */}
              <div className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px">
                <svg
                  width="8px"
                  height="8px"
                  viewBox="0 0 8 8"
                  xmlns="http://www.w3.org/2000/svg"
                  className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
                >
                  <title>tab-radius-l</title>
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                    className={
                      isActive
                        ? "s-fill-scoreboard-tab-bg-active"
                        : "s-fill-scoreboard-tab-bg"
                    }
                  >
                    <path
                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                      transform="translate(4, 4) scale(-1, 1) translate(-4, -4)"
                    />
                  </g>
                </svg>
              </div>

              {/* Right SVG */}
              <div className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px">
                <svg
                  width="8px"
                  height="8px"
                  viewBox="0 0 8 8"
                  xmlns="http://www.w3.org/2000/svg"
                  className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                >
                  <title>tab-radius-r</title>
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                    className={
                      isActive
                        ? "s-fill-scoreboard-tab-bg-active"
                        : "s-fill-scoreboard-tab-bg"
                    }
                  >
                    <path d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z" />
                  </g>
                </svg>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const containerRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ x: 0, width: 0 });
  const [activeIndex, setActiveIndex] = useState(0);
  // Function to update indicator position & width
  const updateIndicator = (index) => {
    if (!containerRef.current) return;

    const tab = containerRef.current.children[index];
    if (tab) {
      const rect = tab.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      setIndicatorStyle({
        x: rect.left - containerRect.left, // X position inside container
        width: rect.width, // Tab width
      });
    }
  };
  // Update indicator on initial load and window resize
  useEffect(() => {
    updateIndicator(activeIndex);

    const handleResize = () => {
      updateIndicator(activeIndex);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeIndex]);

  return (
    <Layout>
      <div id="vueWebComponent" className="cricket-container">
        <s-app data-v-app>
          <div
            id="s-app-container"
            className={`s-app s-space-y-px ${
              isMobile ? "s-default" : " is-desktop"
            }`}
          >
            <div className="s-main-container-wrapper">
              <section
                id="s-main-container"
                className="s-min-h-full-with-header s-mx-auto s-bg-body"
              >
                <main className>
                  {loader ? (
                    <BeforeLoaderDetail />
                  ) : (
                    <div className>
                      <div>
                        <div>
                          <div className="s-score-tab">
                            <div className="s-relative s-h-34px s-overflow-y-hidden s-flex s-items-center s-bg-secondary">
                              <div
                                onClick={() => navigate(-1)}
                                className="s-absolute s-w-44px s-h-full s-flex s-justify-center s-items-center"
                              >
                                <span className="s-icon-arrow-left s-w-14px s-h-14px s-text-14px s-text-white" />
                              </div>

                              <ScoreboardTabs />
                            </div>
                            <div className="s-w-full s-h-4px s-bg-scoreboard-tab-bg-active" />
                          </div>
                          {!["horse", "greyhound"].includes(parmas?.type) &&
                            activeTab == "scoreboard" &&
                            !isEmpty(detail?.scoreId) &&
                            detail?.scoreId != "false" &&
                            displayScore()}
                          {!["horse", "greyhound"].includes(parmas?.type) &&
                          activeTab == "tv" &&
                          !isEmpty(user) &&
                          detail?.status == "in_play" ? (
                            <div
                              className="s-bg-secondary"
                              style={{ height: "auto" }}
                            >
                              <div
                                data-v-4500b3c2
                                className="s-video-contaienr s-relative"
                              >
                                <div
                                  data-v-4500b3c2
                                  className={`s-video-wrapper s-relative s-z-0 ${
                                    tvClass ? "is-outside" : ""
                                  } `}
                                >
                                  {!loading && (
                                    <IoVolumeMuteSharp
                                      onClick={() => setMute(true)}
                                      size={20}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        bottom: "10px",
                                        zIndex: "99999",
                                        color: "white",
                                      }}
                                    />
                                  )}
                                  {loading && (
                                    <div
                                      style={{
                                        padding: "0",
                                        position: "absolute",
                                        margin: "0",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    >
                                      <img
                                        src={LoadingImage}
                                        alt="Thumbnail"
                                        style={{
                                          overflowY: "hidden",
                                          height: "100%",
                                          width: "100%",
                                          overflowX: "hidden",
                                          overflowY: "hidden",
                                        }}
                                      />
                                    </div>
                                  )}
                                  <ReactPlayer
                                    muted={mute}
                                    data-v-4500b3c2
                                    controls={false}
                                    ref={ref}
                                    playsinline={true}
                                    loop={true}
                                    playing={true}
                                    id="videoFrame"
                                    className="s-w-full s-aspect-video s-relative s-z-0"
                                    onReady={() => setLoading(false)} // Video is ready → hide loader
                                    onBuffer={() => setLoading(true)} // When buffering → show loader
                                    onBufferEnd={() => setLoading(false)} // Buffer ends → hide loader
                                    width={"100%"}
                                    height="100%"
                                    url={`https://cceucceu.cc/${detail.channel}/index.m3u8`}
                                    config={{
                                      youtube: {
                                        playerVars: {
                                          showinfo: 1,
                                          fs: 1,
                                          controls: 1,
                                        },
                                      },

                                      file: {
                                        attributes: {
                                          preload: "none",
                                          crossOrigin: "true",
                                        },
                                        hlsOptions: {
                                          startLevel: 3,
                                        },
                                      },
                                    }}
                                  />

                                  <div
                                    onClick={() => setActiveTab("scoreboard")}
                                    data-v-4500b3c2
                                    className="s-btn-close s-w-10 s-h-10 s-absolute s-right-5 s-top-3 s-z-50 s-flex s-justify-center s-items-center s-rounded-full"
                                    style={!tvClass ? { display: "none" } : {}}
                                  >
                                    <span
                                      data-v-4500b3c2
                                      className="s-icon-close s-text-16px s-text-white"
                                    />
                                  </div>
                                </div>
                                <div
                                  data-v-4500b3c2
                                  className="s-absolute s-w-full s-h-0 s-left-0 s-top-0 -s-z-10"
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          id="s-fullmarket-content"
                          className={
                            !isMobile
                              ? "s-pb-120px"
                              : showBetDialog
                                ? "s-min-h-677px s-pb-64"
                                : "s-min-h-677px s-pb-80px"
                          }
                        >
                          {!["multi"].includes(parmas?.type) &&
                            detail?.matchOdds == "on" &&
                            marketNew?.length > 0 && (
                              <div>
                                <div className="s-px-2 s-flex s-justify-between s-items-center s-bg-secondary s-h-34px">
                                  <div className="s-text-base s-text-white s-flex">
                                    Exchange
                                  </div>
                                  <div className="s-flex s-justify-center s-items-center">
                                    <div className>
                                      <span className="s-mr-1 s-text-14px s-text-market-exchange-tip s-opacity-85">
                                        Matched
                                      </span>

                                      <span className="s-text-14px s-text-market-exchange-tip s-font-bold">
                                        BDT{" "}
                                        {formatNumber(
                                          runnerOdds?.totalMatched,
                                        ) || 0.0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-v-d6a4d306
                                  className="market-wrapper s-h-40px s-relative s-bg-primary s-overflow-y-hidden"
                                  style={{
                                    "--0ff97501": `${
                                      indicatorStyle?.width ||
                                      (!isMobile ? 130 : 96)
                                    }px`,
                                    "--ac778322": `translateX(${
                                      indicatorStyle?.x || 7
                                    }px)`,
                                  }}
                                >
                                  <div
                                    data-v-d6a4d306
                                    className="s-h-full s-inline-block"
                                  >
                                    <ul
                                      ref={containerRef}
                                      data-v-d6a4d306
                                      className="s-ml-2 s-mr-1 s-h-full s-flex s-flex-nowrap s-justify-start s-items-center s-text-market-name"
                                      style={{ "pointer-events": "auto" }}
                                    >
                                      {marketNew?.map((res, index) => {
                                        let animate = !isEmpty(
                                          detail?.favourites?.find((obj) => {
                                            return (
                                              res?.marketId ==
                                              obj?.favoriteMarketId
                                            );
                                          }),
                                        );
                                        return (
                                          <li
                                            onClick={(e) => {
                                              {
                                                setMarketName(res?.market);
                                                setActiveIndex(index);
                                                getMatchOdds(res?.marketId);
                                                getBetPosition(res?.marketId);
                                                setRunner(res?.jsonData);
                                                setMarketId(res?.marketId);
                                              }
                                            }}
                                            data-v-d6a4d306
                                            className="s-mr-15px s-px-2px s-h-full s-flex s-gap-3px s-items-center s-whitespace-nowrap"
                                          >
                                            <div
                                              data-v-5460a16b
                                              className="s-fav s-text-market-name dark:s-text-market-name s-text-16px s-mb-3px"
                                            >
                                              <div
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  addToFavioute(
                                                    detail?.eventId,
                                                    "Match Odds",
                                                    res?.marketId,
                                                    res?.market,
                                                  );
                                                }}
                                                className={`s-relative s-icon-star${
                                                  animate
                                                    ? "-solid s-animate-star-line-box"
                                                    : ""
                                                }`}
                                                data-v-5460a16b
                                              >
                                                <span
                                                  data-v-5460a16b
                                                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                                                    animate
                                                      ? "s-animate-star-line"
                                                      : ""
                                                  } `}
                                                />
                                                <span
                                                  data-v-5460a16b
                                                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                                                    animate
                                                      ? "s-animate-star-line"
                                                      : ""
                                                  } `}
                                                />
                                                <span
                                                  data-v-5460a16b
                                                  className={`s-rating-star-line s-bg-market-name dark:s-bg-market-name ${
                                                    animate
                                                      ? "s-animate-star-line"
                                                      : ""
                                                  } `}
                                                />
                                              </div>
                                            </div>
                                            <span
                                              className={`s-text-16px ${
                                                res?.market == marketName
                                                  ? "s-font-bold"
                                                  : ""
                                              } `}
                                            >
                                              {res?.market}
                                            </span>
                                          </li>
                                        );
                                      })}
                                    </ul>

                                    <motion.div
                                      data-v-d6a4d306
                                      className="tab-indicator s-h-3px s-absolute s-left-0 s-bottom-2 s-rounded-1.5px s-bg-market-name"
                                      style={{ pointerEvents: "auto" }}
                                    />
                                  </div>
                                </div>

                                {detail?.matchOdds == "on" &&
                                  runner?.length > 0 && (
                                    <Selection
                                      runner={runner}
                                      name={marketName}
                                      marketId={marketId}
                                      totalMatched={totalMatched}
                                      backOdds={backOdds}
                                      layOdds={layOdds}
                                      oldBack={oldBack}
                                      oldLay={oldLay}
                                      detail={detail}
                                      ms={ms}
                                      position={positionMemo}
                                      profileData={profileDataMemo}
                                      typeGame="betFaire"
                                      marketName={marketName}
                                      user={user}
                                      addToFavioute={addToFavioute}
                                    />
                                  )}
                              </div>
                            )}
                          {!["multi"].includes(parmas?.type) && (
                            <div className="s-py-12px s-flex s-gap-12px s-flex-col s-px-7px">
                              {" "}
                              {detail?.bookMaker == "on" &&
                                detail?.gameType == "cricket" &&
                                bookmaker?.length > 0 && (
                                  <Bookmaker
                                    runner={bookmaker}
                                    marketId={parmas?.marketId}
                                    detail={detail}
                                    backOdds={backOddsBookmaker}
                                    layOdds={layOddsBookmaker}
                                    oldBack={oldBackBookmaker}
                                    oldLay={oldLayBookmaker}
                                    ms={
                                      detail?.bookMaker == "on"
                                        ? bookmakerOdds?.ms
                                        : 3
                                    }
                                    position={positionMemoBookmaker}
                                    profileData={profileDataMemo}
                                    addToFavioute={addToFavioute}
                                    typeGame="bookmaker"
                                    marketName={"Bookmaker"}
                                    user={user}
                                  />
                                )}
                              {(showSportbook || showFancy) && (
                                <div className="s-shadow-2sm s-rounded-b-5px">
                                  <section className="s-pt-2 s-px-12px s-bg-primary s-rounded-t-5px">
                                    <div className="s-flex s-bg-market-tab-bg s-w-max s-rounded-t-md">
                                      {showFancy && (
                                        <div
                                          onClick={() => setFancyTab("Fancy")}
                                          className="s-relative s-text-16px s-z-20"
                                        >
                                          <div>
                                            <div
                                              className={`${
                                                fancyTab == "Fancy"
                                                  ? "s-bg-market-tab-bg-active"
                                                  : ""
                                              }  s-relative s-tab s-w-100px s-h-33px s-py-2 s-rounded-t-md`}
                                            >
                                              <div
                                                data-v-e6652d81
                                                className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px"
                                              >
                                                <svg
                                                  data-v-e6652d81
                                                  width="8px"
                                                  height="8px"
                                                  viewBox="0 0 8 8"
                                                  version="1.1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
                                                >
                                                  <title data-v-e6652d81>
                                                    tab-radius-l
                                                  </title>
                                                  <g
                                                    data-v-e6652d81
                                                    id="Page-1"
                                                    stroke="none"
                                                    strokeWidth={1}
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    data-is-selected="true"
                                                    className="s-fill-market-tab-bg-active"
                                                  >
                                                    <path
                                                      data-v-e6652d81
                                                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                                                      id="tab-radius-l"
                                                      transform="translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) "
                                                    />
                                                  </g>
                                                </svg>
                                              </div>

                                              <div
                                                data-v-16f79fce
                                                className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px"
                                              >
                                                <svg
                                                  data-v-16f79fce
                                                  width="8px"
                                                  height="8px"
                                                  viewBox="0 0 8 8"
                                                  version="1.1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                                                >
                                                  <title data-v-16f79fce>
                                                    tab-radius-r
                                                  </title>
                                                  <g
                                                    data-v-16f79fce
                                                    id="Page-1"
                                                    stroke="none"
                                                    strokeWidth={1}
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    data-is-selected="true"
                                                    className="s-fill-market-tab-bg-active"
                                                  >
                                                    <path
                                                      data-v-16f79fce
                                                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                                                      id="tab-radius-r"
                                                    />
                                                  </g>
                                                </svg>
                                              </div>
                                            </div>
                                            <span className="s-text-market-tab-text-active s-font-bold s-left-1/2 s-left-1/2 s-absolute s-top-1/2 s--translate-y-1/2 s--translate-x-1/2">
                                              Fancy
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {showSportbook && (
                                        <div
                                          onClick={() => setFancyTab("Premium")}
                                          className="s-relative s-text-16px s-z-20"
                                        >
                                          <div>
                                            <div
                                              className={`${
                                                fancyTab == "Premium"
                                                  ? "s-bg-market-tab-bg-active"
                                                  : ""
                                              }  s-relative s-tab s-w-100px s-h-33px s-py-2 s-rounded-t-md`}
                                            >
                                              <div
                                                data-v-e6652d81
                                                className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px"
                                              >
                                                <svg
                                                  data-v-e6652d81
                                                  width="8px"
                                                  height="8px"
                                                  viewBox="0 0 8 8"
                                                  version="1.1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
                                                >
                                                  <title data-v-e6652d81>
                                                    tab-radius-l
                                                  </title>
                                                  <g
                                                    data-v-e6652d81
                                                    id="Page-1"
                                                    stroke="none"
                                                    strokeWidth={1}
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    data-is-selected="true"
                                                    className="s-fill-market-tab-bg-active"
                                                  >
                                                    <path
                                                      data-v-e6652d81
                                                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                                                      id="tab-radius-l"
                                                      transform="translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) "
                                                    />
                                                  </g>
                                                </svg>
                                              </div>

                                              <div
                                                data-v-16f79fce
                                                className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px"
                                              >
                                                <svg
                                                  data-v-16f79fce
                                                  width="8px"
                                                  height="8px"
                                                  viewBox="0 0 8 8"
                                                  version="1.1"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                  className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                                                >
                                                  <title data-v-16f79fce>
                                                    tab-radius-r
                                                  </title>
                                                  <g
                                                    data-v-16f79fce
                                                    id="Page-1"
                                                    stroke="none"
                                                    strokeWidth={1}
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    data-is-selected="true"
                                                    className="s-fill-market-tab-bg-active"
                                                  >
                                                    <path
                                                      data-v-16f79fce
                                                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                                                      id="tab-radius-r"
                                                    />
                                                  </g>
                                                </svg>
                                              </div>
                                            </div>
                                            <span className="s-text-market-tab-text-active s-font-bold s-left-1/2 s-left-1/2 s-absolute s-top-1/2 s--translate-y-1/2 s--translate-x-1/2">
                                              Sportsbook
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </section>
                                  {fancyTab == "Fancy" &&
                                    parmas?.type != "multi" &&
                                    showFancy && (
                                      <Fancy
                                        fancy={fancy}
                                        detail={detail}
                                        fancyHeader={fancyHeader}
                                        position={fancyPosition}
                                        typeGame={"fancy"}
                                        profileData={
                                          detail?.matchSetting?.length > 0
                                            ? {
                                                ...detail,
                                                arrayCheck: "details",
                                                profile: profileData,
                                              }
                                            : {
                                                ...profileData,
                                                arrayCheck: "profile",
                                                profile: profileData,
                                              }
                                        }
                                        setFancyModal={setFancyModal}
                                        addToFavioute={addToFavioute}
                                        favouriteList={favouriteList}
                                      />
                                    )}
                                  {(parmas?.type == "multi"
                                    ? true
                                    : fancyTab == "Premium") &&
                                    showSportbook && (
                                      <SportsBook
                                        data={sportsBook}
                                        user={user}
                                        favouriteList={favouriteList}
                                        detail={detail}
                                        position={sportsBookPosition}
                                        setBetSlipObject={setBetSlipObject}
                                        betSlipObject={betSlipObject}
                                        BetSlip={BetSlip}
                                        profileData={
                                          detail?.matchSetting?.length > 0
                                            ? {
                                                ...detail,
                                                arrayCheck: "details",
                                              }
                                            : {
                                                ...profileData,
                                                arrayCheck: "profile",
                                              }
                                        }
                                        addToFavioute={addToFavioute}
                                      />
                                    )}
                                </div>
                              )}
                            </div>
                          )}
                          {parmas?.type == "multi" && (
                            <ParlaySportbook
                              data={sportsBook}
                              user={user}
                              favouriteList={favouriteList}
                              detail={detail}
                              position={sportsBookPosition}
                              setBetSlipObject={setBetSlipObject}
                              betSlipObject={betSlipObject}
                              BetSlip={BetSlip}
                              profileData={
                                detail?.matchSetting?.length > 0
                                  ? {
                                      ...detail,
                                      arrayCheck: "details",
                                    }
                                  : {
                                      ...profileData,
                                      arrayCheck: "profile",
                                    }
                              }
                              addToFavioute={addToFavioute}
                            />
                          )}
                        </div>
                        <MyBets /> <BetSlip />
                        <BetSlipParly />
                        {!isEmpty(user) && <BetSlipIcon detail={detail} />}{" "}
                        {!isEmpty(fancyModal?.object) && fancyModal?.status && (
                          <BookPosition
                            object={fancyModal?.object}
                            setFancyModal={setFancyModal}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </main>
              </section>
              {toastObject?.status && (
                <CustomToast
                  type={toastObject?.type}
                  title={toastObject?.title}
                  message={toastObject?.message}
                  onClose={() => setToastObject({})}
                  playType={toastObject?.playType}
                />
              )}
            </div>
          </div>
        </s-app>
      </div>
    </Layout>
  );
};

export default MatchDetail;
